export enum EntryFlowEndPoints {
	// * signin
	signin = '/v1/entry-flow/auth/signin',
	refreshToken = '/v1/entry-flow/auth/refresh-token',
	refreshTokenV2 = '/v2/entry-flow/auth/refresh-token',

	// * signup
	signUpCheckExistence = '/v1/entry-flow/sign-up/cadastros',
	signUpSendToken = '/v1/entry-flow/sign-up/cadastro/novo',
	signUpResendToken = '/v1/entry-flow/sign-up/cadastros/reenvio',
	signUpValidateToken = '/v1/entry-flow/sign-up/cadastro/token/validar',
	// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
	signUpConfirm = '/v1/entry-flow/sign-up/cadastros',
	signUpUpdate = '/v1/entry-flow/auth/change-password',
	signUpCheckUserExistence = '/v1/entry-flow/sign-up/check-user-existence',
	signUpNewPassword = '/v1/entry-flow/sign-up/new-password',

	// * forgot-password
	forgotRecoverUserInfo = '/v1/entry-flow/forgot-password/esqueci/usuario',
	forgotResendToken = '/v1/entry-flow/forgot-password/resgates/reenvio',
	forgotConfirm = '/v1/entry-flow/forgot-password/esqueci/confirmar',

	// * new-forgot-password

	forgotSendToken = '/v1/entry-flow/auth/send-token',
	forgotReSendToken = '/v1/entry-flow/auth/resend-token',
	forgotValidateToken = '/v1/entry-flow/auth/check-token',
	forgotConfirmRegistration = '/v1/entry-flow/auth/confirm-registration',
}

export enum B2BEndPoints {
	companyPortal = '/v1/authorization-flow/company-portal',
	companyAuthorization = '/v1/company-authorization/status-flag',
	permissionCompany = '/v1/company-authorization/enable',
}

export enum BeneficiaryEndpoints {
	// * plan
	planListV3 = '/v3/entry-flow/beneficiary/plans',
	planListV4 = '/v4/entry-flow/beneficiary/plans',

	// * beneficiary
	beneficiaryList = '/v1/entry-flow/beneficiary/beneficiaries',
	beneficiaryListV3 = '/v3/entry-flow/beneficiary/beneficiaries',
	beneficiarySelection = '/v1/entry-flow/beneficiary',
	beneficiaryContacts = '/v1/entry-flow/beneficiary/contacts',

	// * sidebar
	sidebar = '/v1/entry-flow/beneficiary/sidebar',
}

export enum HealthCardEndPoint {
	healthCard = '/v1/wallet-flow/wallet',
}

export enum BannersEndPoint {
	banners = '/v1/publicity/management-banner',
	bannersV2 = '/v2/publicity/management-banner',
}

export enum HomeEndPoints {
	home = '/v2/entry-flow/beneficiary/home',
	homeV3 = '/v3/entry-flow/beneficiary/home',
	homeOperationalCostPassword = '/v1/entry-flow/beneficiary/operational-costs/password',
	registrationUpdateStatus = '/v1/atualizacao-cadastral/status',
	registrationUpdateConfirm = '/v1/atualizacao-cadastral/confirm',
	congenereEligibility = '/v1/montes-claros-mg/elegibility',
	contractualTermPending = '/v1/contractual-term/pending',
	contractualTermLojasTorra = '/v1/contractual-term/lojas-torra',
	contractualTermAccept = '/v1/contractual-term/accept',
}

export enum FeatureFlagEndpoint {
	featureFlag = '/v2/feature-flag',
}

export enum ExternalLinkPoint {
	additionalCoverage = '/v1/links-flow/beneficiary/additional-benefits',
	chatRoom = '/v1/chat-flow/chat',
	chatRoomv2 = '/v2/chat-flow/chat',
	teleconsultation = '/v1/teleconsultation-flow/teleconsultation',
	emergency = '/v1/telehealth/urgency',
	emergencyV3 = '/v3/telehealth/urgency',
	perksClub = '/v1/hapvida-club/url',
	authorization = '/v1/entry-flow/authorization/url',
	examResults = '/v1/booked-flow/exams/results-url',
	hospitalization = '/v1/hospitalization-flow/url',
	registerManual = '/v1/publicity/register-manual-pdf',
	solusPortal = '/v1/entry-flow/solus-portal/url',
	serviceCenter = '/v1/links-flow/service-center',
	debtSettlementStatement = '/v1/links-flow/debt-settlement-statement',
	portabilityCard = '/v1/links-flow/portability-card',
	pinSs = '/v1/links-flow/pin-ss',
	recommendation = '/v1/recommendations/auth-url',
	contractOnline = '/v1/links-flow/contract-online',
	privacyPolicy = '/v1/links-flow/privacy-policy',
	support = '/v1/links-flow/customer-service',
	womenChannel = '/v1/links-flow/women-channel',
	faq = '/v1/links-flow/faq',
	stayLetter = '/v1/my-payments-flow/letter-permanence-pdf',
	refundOdonto = '/v1/links-flow/odonto-refund-url',
	beneficiaryDocument = '/v1/links-flow/beneficiary-document',
	units = '/v1/links-flow/ndi/units',
	accessUserManual = '/v1/handbook/handbooks',
	featuresUserManual = '/v1/handbook/handbookAuth',
	refundUserManual = '/v1/refund-flow/ppo-reimbursement-guide',
	whoIndicates = '/v1/who-indicates/url',
	waitingPeriod = '/v1/links-flow/waiting-period-url',
}

export enum MyReferralsFlowEndPoints {
	referrals = '/v1/my-referrals/procedures',
	referralDetails = '/v1/my-referrals/procedure',
}

export enum BookingFlowEndPoints {
	// * health
	healthStates = '/v2/booking-flow/health/states',
	healthCities = '/v2/booking-flow/health/cities',
	healthSpecialties = '/v2/booking-flow/health/specialties',
	cityLocation = '/v1/booking/health/geolocation/city-location',
	healthClinics = '/v2/booking-flow/health/clinics',
	healthDates = '/v2/booking-flow/health/dates',
	healthAvailableTimes = '/v2/booking-flow/health/providers',
	healthOpenScheduling = '/v1/booking-flow/health/open-scheduling',
	healthScheduledAppointments = '/v2/booking-flow/health/scheduled-appointments',
	healthSpecialtyAuthorization = '/v1/booking-flow/health/speciality/authorization',
	healthSpecialtyAuthorizationScript = '/v1/booking-flow/health/speciality/smart-schedule',
	healthSpecialtyEligibilityScript = '/v1/booking/smartschedule/scheduler-script/check-eligibility',
	healthDateAuthorization = '/v1/booking-flow/health/speciality/date/authorization',
	healthLocalities = '/v2/booking-flow/health/localities',
	healthProviderLocation = '/v2/booking-flow/health/provider-location',
	healthFavoriteProviderLocation = '/v2/booking-flow/health/clinics-from-favorite-providers',
	healthSpecialtiesLocalities = '/v2/booking-flow/health/specialties-localities',
	healthRequestSchedule = '/v1/booking-flow/health/entry-queue',
	healthRequestSchedulePermission = '/v1/booking-flow/health/queue-permission',
	scriptQuestions = '/v1/booking-flow/health/speciality-question',
	scriptQuestionsAndAnswers = '/v1/booking/smartschedule/scheduler-script/chat',
	scriptAnswer = '/v1/booking-flow/health/speciality-answer',
	healthProviderLocationSupportAccredited = '/v1/booking-flow/health/provider-location-support-accredited-merged',
	healthProviderLocationPreview = '/v1/booking-flow/health/provider-location-preview',
	healthDistricts = '/v1/booking-flow/health/districts',
	healthVerifySpecialties = '/v1/booking-flow/health/verify-specialties',
	healthSpecialtyDescription = '/v2/booking-flow/health/specialty-description',

	// * odonto
	odontoStates = '/v1/booking-flow/odonto/states',
	odontoCities = '/v1/booking-flow/odonto/cities',
	odontoSpecialties = '/v1/booking-flow/odonto/specialties',
	odontoDistricts = '/v1/booking-flow/odonto/districts',
	odontoProviders = '/v1/booking-flow/odonto/providers',
	odontoDates = '/v1/booking-flow/odonto/dates',
	odontoAvailableTimes = '/v1/booking-flow/odonto/available-times',
	odontoBookingConfirm = '/v1/booking-flow/odonto/book',
	odontoProviderAddress = '/v1/booking-flow/odonto/address-physical-providers',
	odontoVerifySpecialties = '/v1/booking-flow/odonto/verify-specialties',

	// * exams
	examStates = '/v1/booking-flow/exams/states',
	examStatesV3 = '/v3/booking-flow/exams/locations/states',
	examCities = '/v1/booking-flow/exams/cities',
	examPreparation = '/v1/booked-flow/exams/preparo-exams',
	examPreparationV3 = '/v3/booking-flow/exams/preparations',
	examAuthorizedPrePassword = '/v1/booking-flow/exams/prepassword',
	examAuthorizedPassword = '/v1/booking-flow/exams/password',
	examsTypes = '/v1/booking-flow/exams/types',
	examAuthorizedPasswordV3 = '/v3/booking-flow/exams/password',
	examsTypesLocation = '/v1/booking-flow/exams/exam-type-location',
	examProviders = '/v1/booking-flow/exams/providers',
	examDates = '/v1/booking-flow/exams/dates',
	examDatesV3 = '/v3/booking-flow/exams/availability-grace-period',
	examTimes = '/v1/booking-flow/exams/available-times',
	examBookingConfirm = '/v1/booking-flow/exams/book',
	examBookingConfirmV3 = '/v3/booking-flow/exams/book',
	examsAuthorization = '/v1/booking-flow/exams/authorization',
	examsAuthorizationV3 = '/v3/booking-flow/exams/authorization',
	examLocalities = '/v1/booking-flow/exams/localities',
	examTimesV3 = '/v3/booking-flow/exams/availability-times',
	examLocalitiesV3 = '/v3/booking-flow/exams/locations',
	examProviderLocation = '/v1/booking-flow/exams/provider-location',
	examProvidersLocationAccredited = '/v1/booking-flow/exams/provider-location-accredited',
	examDistricts = '/v1/geolocation/available-neighborhood-exam',
	examDistrictsV3 = '/v3/booking-flow/exams/locations/neighborhoods',

	// * surgery
	surgeryConfirm = '/v2/booking-flow/surgery/confirm',
}

export enum BookedFlowEndPoints {
	// * odonto
	odontoBooked = '/v1/booked-flow/odonto/schedules',
	odontoBookedConfirm = '/v1/booked-flow/odonto/confirm',
	odontoRebooking = '/v1/booked-flow/odonto/reschedule',
	odontoCancel = '/v1/booked-flow/odonto/cancel',

	// * health
	healthScheduledAppointmentsLast = '/v2/booked-flow/health/scheduled-appointments/last',

	// * exams
	examsBooked = '/v1/booked-flow/exams/schedules',
	examsBookedV3 = '/v3/booked-flow/exams/schedules',
	examsBookedConfirm = '/v1/booked-flow/exams/confirm',
	examsRebooking = '/v1/booked-flow/exams/reschedule',
	examsCancel = '/v1/booked-flow/exams/cancel',
	examResults = '/v1/booked-flow/exams/results',
	examRequests = '/v1/booked-flow/exams/requests',
	examRequestReports = '/v1/booked-flow/exams/requests/:nuPedido/reports',

	medicalReport = '/v1/booked-flow/exams/medical-report',

	appointmentsTelehealthDocs = '/v1/telehealth/docs/emergency',
	healthAppointmentsHistory = '/v2/booked-flow/health/scheduled-appointments/history',

	appointmentAttachments = '/v1/consultations/:nuControle/attachments',
}

export enum GuideFlowEndpoints {
	// * odonto
	odontoGuideCities = '/v1/guide-flow/dental-guide/get-cities',
	odontoGuideStates = '/v1/guide-flow/dental-guide/get-states',
	odontoGuideServices = '/v1/guide-flow/dental-guide/get-services',
	odontoGuideProviders = '/v1/guide-flow/dental-guide/providers',
	odontoGuideSpecialties = '/v1/guide-flow/dental-guide/get-specialties',
	odontoGuideNeighborhoods = '/v1/guide-flow/dental-guide/get-neighborhoods',
	odontoGuideProvidersDetails = '/v1/guide-flow/dental-guide/get-providers-details',

	// * medical
	medicalGuideCities = '/v1/guide-flow/medical-guide/get-cities',
	medicalGuideStates = '/v1/guide-flow/medical-guide/get-states',
	medicalGuideServices = '/v1/guide-flow/medical-guide/get-services',
	medicalGuideProviders = '/v1/guide-flow/medical-guide/get-providers',
	medicalGuideProvidersV3 = '/v3/guide-flow/medical-guide/get-providers',
	medicalGuideProcedureV3 = '/v3/guide-flow/medical-guide/procedure',
	medicalGuideSpecialties = '/v1/guide-flow/medical-guide/get-specialties',
	medicalGuideProvidersDetails = '/v1/guide-flow/medical-guide/get-providers-details',
	medicalGuideTypeNetwork = '/v1/guide-flow/medical-guide/type-network',
	medicalGuideDistricts = '/v1/guide-flow/medical-guide/get-districts',
	medicalSearchProcedure = '/v1/guide-flow/medical-guide/search-procedure',
	medicalFavoritePlace = '/v1/beneficiary-flow/favorite-addresses',
	medicalFavoriteDoctors = '/v1/guide-flow/medical-guide/favorite-doctors',
}

export enum MyPaymentsFlowEndPoints {
	payments = '/v1/my-payments-flow/payments',
	invoices = '/v1/my-payments-flow/invoices',
	paymentsSaoLucas = '/v1/my-payments-flow/payments/sao-lucas',
	paymentsPdf = '/v1/my-payments-flow/payments/pdf',
	paymentsHistory = '/v1/my-payments-flow/payments/history',
	paymentsHistoryYears = '/v1/my-payments-flow/payments/history/years',
	incomeTax = '/v1/my-payments-flow/income',
	incomeTaxPDF = '/v1/my-payments-flow/income/pdf',
	invoicesRecover = '/v1/financial-flow/invoices/recover',
	invoicePdf = '/v1/financial-flow/invoice/pdf',
	electronicBill = '/v1/my-payments-flow/set-electronic-bill',
	adherenceDigitalPayment = '/v1/my-payments-flow/adherence-digital-payment',
	checkoutPayment = '/v1/my-payments-flow/checkout/payment',
	checkoutRecurrence = '/v1/my-payments-flow/checkout/recurrence',
	graceBotEvent = '/v1/my-payments-flow/event-grace-bot',
}

export enum FiveStarsFlowEndPoints {
	fiveStarsFlow = '/v1/five-stars-flow/five-stars',
}

export enum RefundFlowEndPoints {
	// request
	beneficiaries = '/v1/refund-flow/beneficiaries',
	plans = '/v1/refund-flow/plans',
	banks = '/v1/refund-flow/banks',
	validateBank = '/v1/refund-flow/banks/validate',
	therapies = '/v1/refund-flow/therapies',
	specialties = '/v1/refund-flow/specialties',
	procedureTherapies = '/v1/refund-flow/procedure-therapies',
	modalities = '/v1/refund-flow/modalities',
	professionals = '/v1/refund-flow/providers',
	professionalCouncils = '/v1/refund-flow/professionals-councils',
	tableUrl = '/v1/refund-flow/refund-table',
	beneficiaryBankData = '/v1/refund-flow/beneficiary-bank',
	states = '/v1/refund-flow/states',
	cities = '/v1/refund-flow/cities',
	protocol = '/v1/refund-flow/protocol',
	protocols = '/v1/refund-flow/protocols',
	updateBatchProcedure = '/v1/refund-flow/protocols/:protocolCode/requests/:requestCode/procedures',
	procedure = '/v1/refund-flow/procedure',
	protocolStatus = '/v1/refund-flow/protocol/status',
	request = `/v1/refund-flow/:protocolCode/finish`,
	attachment = '/v1/refund-flow/attachment',
	consultRefunds = '/v1/refund-flow/consult-refunds',
	requestProtocolPdf = '/v1/refund-flow/request-protocol-pdf',
	consultPreviewRefunds = '/v1/refund-flow/consult-preview-refunds',
	requestPreviewProtocolPdf = '/v1/refund-flow/request-preview-protocol-pdf',
	checkRequestProtocol = '/v1/refund-flow/check-request',
	requestPreview = '/v1/refund-flow/request-preview',
	previewsProcedure = '/v1/refund-flow/previews-procedure',
	previewsAnalysis = '/v1/refund-flow/previews-analysis',
	requestPreviewAttachment = '/v1/refund-flow/request-preview/attachment',
	procedures = '/v1/refund-flow/procedures',
	listEligibleProcedures = '/v1/refund-flow/list-eligible-procedures',
	additionalDocumentsSearch = '/v1/refund-flow/additional-documents/search',
	additionalDocumentsCreate = '/v1/refund-flow/additional-documents',
	calculateReimbursementPreview = '/v1/refund-flow/calculate-reimbursement-preview',
	additionalDocumentsRequests = '/v1/refund-flow/additional-documents/requests',
}

export enum AuthorizationsFlowEndpoints {
	uf = '/v1/authorization-flow/states',
	cities = '/v1/authorization-flow/nopagecities',
	status = '/v1/authorization-flow/status',
	requests = '/v1/authorization-flow/requests',
	authorizations = '/v1/authorization-flow/authorizations',
	beneficiaries = '/v1/authorization-flow/beneficiaries',
	detail = '/v1/authorization-flow/request',
	register = '/v1/authorization-flow/request/:nuControle/register',
	printGuide = '/v1/authorization-flow/request/guide/print',
	uploadFile = '/v1/authorization-flow/request/:nuControle/file/',
	deleteFile = '/v1/authorization-flow/request/:nuControle/file/:nuArquivo',
	recoverFile = '/v1/authorization-flow/recover-file',
	schedule = '/v1/authorization-flow/messageholidayEnabledOrDisabled',
	denialLetter = '/v1/authorization-flow/rejected-requests/pdf',
	providers = '/v1/authorization-flow/providers',
}

export enum HelpDeskFlowEndpoints {
	newSac = '/v1/helpdesk/new-sac',
	ombudsman = '/v1/contact-us/sac/link-page',
}

export enum ProfileChangeDataEndpoints {
	checkCellPhone = '/v1/beneficiary-flow/celular',
	resendConfirmCellPhone = '/v1/beneficiary-flow/celular/resend',

	checkEmail = '/v1/beneficiary-flow/email',
	resendConfirmEmail = '/v1/beneficiary-flow/email/resend',

	contactsData = '/v2/beneficiary/contacts',

	changeAddress = '/v2/beneficiary/address',
	beneficiaryAddressV4 = '/v4/beneficiary/address',
	beneficiaryAddressSuggestionV4 = '/v4/beneficiary/address/suggestion',

	reverseGeocode = '/v3/geocode/reverse',

	addressUpdateIndicatorV4 = '/v4/beneficiary/address/update-indicator',
	addressConfirmV4 = '/v4/beneficiary/address/:sequence/confirm',
}

export enum AccessManagementEndpoints {
	features = '/v1/access-management/features',
	permissions = '/v1/access-management/permitions',
}

export enum FranchisesTableFlowEndpoints {
	franchises = '/v1/booking-flow/odonto/procedure',
}

export enum BeneficiaryTokenEndpoints {
	beneficiaryToken = '/v1/beneficiary-token',
}

export enum TeaFormFlowEndpoints {
	teaForm = '/v2/links-flow/tea-form',
}

export enum consultProtocolsFlowEndpoints {
	consultProtocols = '/v1/protocols-flow/consult-protocols',
	consultProtocolsTrack = '/v1/protocols-flow/consult-protocols/track',
}

export enum communicationsFlowEndpoints {
	communications = '/v1/communication-flow/communications',
	confirmation = '/v1/communication-flow/confirm',
}

export enum LifeplaceEndpoints {
	lifePlaceLink = '/v1/ecommerce/life-place/link',
	lifePlaceProducts = '/v1/ecommerce/life-place/products',
}

export enum ConciergeEndPoint {
	url = '/v1/concierge/my-hospitalization/link',
}

export enum WellBornEndpoints {
	eligibility = '/v1/well-born/eligibility',
	declineProgram = '/v1/well-born/decline-program',
	acceptProgram = '/v1/well-born/accept-program',
}

export enum authorizationsOdontoFlowEndpoints {
	authorizationsOdontoTrack = '/v1/booking-flow/odonto/status-authorization/track',
	authorizationsOdontoHistory = '/v1/booking-flow/odonto/authorization-history',
	authorizationsOdontoDenialLetter = '/v1/booking-flow/odonto/denial-letter/pdf',
}
export enum MyHospitalizationEndpoints {
	opinionsList = '/v1/concierge/my-hospitalization/opinions-list',
	patientData = '/v1/concierge/my-hospitalization/hospitalized',
	examsList = '/v1/concierge/my-hospitalization/exams-list',
	doctorVisitsList = '/v1/concierge/my-hospitalization/visitors-list',
	proceduresList = '/v1/concierge/my-hospitalization/procedures-list',
	prescriptionsList = '/v1/concierge/my-hospitalization/prescriptions-list',
	loggingAccess = '/v1/concierge/logging-access/beneficiary',
}

export enum ContentEndpoints {
	content = '/v1/entry-flow/content-manager/search-content',
}

export enum OurDoctorEndpoints {
	ourDoctor = '/v1/entry-flow/our-doctor-message',
}

export enum ProfileEndpoints {
	progress = '/v1/my-profile/progress',
}

export enum FacialBiometricEndpoints {
	consult = '/v1/bioface/consult',
	register = '/v1/bioface/register',
	photoDoc = '/v1/bioface/photo-doc',
	identification = '/v1/bioface/identification',
	preRegister = '/v1/bioface/pre-register',
	preRegisterConsult = '/v1/bioface/pre-register/consult',
	registerDocument = '/v1/bioface/register-document',
}

export enum VoiceTranscriptionEndpoints {
	termsAccept = '/v1/transcription/terms',
}

export enum ServicePointsEndpoints {
	getServicePoints = '/v1/clinics-adressess/all',
	getServicePointsUfs = '/v1/clinics-adressess/ufs',
}
